import socketNotification from './socket-notification';

export default {
  socketNotification,
};
